<template>
  <main class="main">
    <h1 class="app-title">Bolisbil?</h1>

    <div class="input-toggle" role="group" aria-label="Input method">
      <button
        class="toggle-btn"
        :class="{ active: inputMode === 'voice' }"
        @click="inputMode = 'voice'"
      >Voice</button>
      <button
        class="toggle-btn"
        :class="{ active: inputMode === 'keyboard' }"
        @click="inputMode = 'keyboard'"
      >Keyboard</button>
    </div>

    <div class="input-bottom">
      <section v-if="inputMode === 'voice'" class="input-section voice-section" aria-label="Voice input">
        <VoiceInputButton @transcribed="fillFromTranscription" />
      </section>

      <section v-else class="input-section keyboard-section" aria-label="On-screen keyboard">
        <CodeInput :slots="slots" :cursor="cursor" />
        <OnScreenKeyboard
          :mode="keyboardMode"
          @key="inputChar"
          @backspace="backspace"
          @mode-change="setKeyboardMode"
        />
      </section>
    </div>
  </main>
</template>

<script setup lang="ts">
import { ref, watch } from 'vue';
import { useRouter } from 'vue-router';
import CodeInput from '../components/CodeInput.vue';
import OnScreenKeyboard from '../components/OnScreenKeyboard.vue';
import VoiceInputButton from '../components/VoiceInputButton.vue';
import { useCodeInput } from '../composables/useCodeInput.ts';

const inputMode = ref<'voice' | 'keyboard'>('voice');

const router = useRouter();
const { slots, cursor, keyboardMode, code, inputChar, backspace, fillFromTranscription, setKeyboardMode } = useCodeInput();

watch(code, (newCode) => {
  if (newCode !== null) {
    router.push(`/result/${newCode}`);
  }
});
</script>

<style scoped>
.main {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 3rem 1rem 1.5rem;
  gap: 1.5rem;
  max-width: 540px;
  margin: 0 auto;
  width: 100%;
}

.input-bottom {
  margin-top: auto;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.5rem;
  margin-bottom: 2rem;
}

.app-title {
  font-size: 1.5rem;
  font-weight: 700;
  margin: 0;
  text-align: center;
  color: #1f2937;
}

@media (prefers-color-scheme: dark) {
  .app-title {
    color: #f9fafb;
  }
}


.keyboard-section {
  width: 100%;
}

.input-toggle {
  display: flex;
  border-radius: 0.5rem;
  overflow: hidden;
  border: 1px solid #d1d5db;
}

.toggle-btn {
  flex: 1;
  padding: 0.5rem 1.25rem;
  border: none;
  background: transparent;
  cursor: pointer;
  font-size: 0.95rem;
  color: #6b7280;
  transition: background 0.15s, color 0.15s;
}

.toggle-btn.active {
  background: #2563eb;
  color: #fff;
}

@media (prefers-color-scheme: dark) {
  .input-toggle {
    border-color: #374151;
  }

  .toggle-btn {
    color: #9ca3af;
  }

  .toggle-btn.active {
    background: #3b82f6;
    color: #fff;
  }
}
</style>
